import { Stack, StackProps } from '@landler/component-library';

export const StackWidget = ({ ...delegated }: StackProps) => {
  return <Stack {...delegated} />;
};
